import { Link } from 'react-router-dom';
import { Speaker, ArrowLeft } from 'lucide-react';

export default function AboutPage() {
  const version = typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : 'dev';
  const buildTimestamp = typeof __BUILD_TIMESTAMP__ !== 'undefined' ? __BUILD_TIMESTAMP__ : null;
  const environment = import.meta.env.MODE;

  const formattedDate = buildTimestamp
    ? new Date(buildTimestamp).toLocaleString()
    : 'N/A';

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-950 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-8">
        <div className="flex items-center gap-3 mb-6">
          <Speaker className="w-10 h-10 text-primary" />
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white">VoteBeats</h1>
        </div>

        <dl className="space-y-4 text-sm">
          <div>
            <dt className="text-gray-500 dark:text-gray-400">Build Version</dt>
            <dd className="font-mono text-gray-900 dark:text-white">{version}</dd>
          </div>
          <div>
            <dt className="text-gray-500 dark:text-gray-400">Build Date</dt>
            <dd className="text-gray-900 dark:text-white">{formattedDate}</dd>
          </div>
          <div>
            <dt className="text-gray-500 dark:text-gray-400">Environment</dt>
            <dd className="text-gray-900 dark:text-white capitalize">{environment}</dd>
          </div>
          <div>
            <dt className="text-gray-500 dark:text-gray-400">Stack</dt>
            <dd className="text-gray-900 dark:text-white">React + Vite + Firebase</dd>
          </div>
        </dl>

        <Link
          to="/"
          className="mt-8 inline-flex items-center gap-2 text-primary hover:underline text-sm"
        >
          <ArrowLeft className="w-4 h-4" />
          Back
        </Link>
      </div>
    </div>
  );
}
